import React, { SyntheticEvent } from 'react';
import { CustomDropdownListElement } from 'src/components/common/CustomDropdownListElement';
import { THelperType } from 'src/utils/i18n';
import { SafeAnyType } from 'src/utils/safeAny';

type Props = {
  actionName: string;
  tHelper: THelperType;
  onClick: (name: SafeAnyType) => (e: SyntheticEvent<HTMLButtonElement | HTMLLinkElement>) => void;

  text?: string;
  icon?: string;
  className?: string;
  active?: boolean;
};

export const GridActionsGenerateItem: React.FC<Props> = ({
  tHelper,
  actionName,
  icon,
  onClick,
  text,
  className,
  active,
}: Props) => (
  <CustomDropdownListElement onClick={onClick(actionName)} active={active} className={className}>
    {icon && <i className="material-icons">{icon || actionName}</i>}
    {text || tHelper(actionName)}
  </CustomDropdownListElement>
);
